import React from 'react';
import { Root, Trigger, Portal, Content } from '@radix-ui/react-dropdown-menu';
import pt from 'prop-types';

import './dropdown-menu.scss';

/**
 * Displays a menu to the user—such as a set of actions or functions—triggered by a button
 */
export default class DropdownMenu extends React.PureComponent {
  static propTypes = {
    disabled: pt.bool,
    rootRest: pt.object,
    triggerChildren: pt.node.isRequired,
    triggerClassName: pt.string,
    triggerRest: pt.object,
    contentClassName: pt.string,
    contentRest: pt.object,
    children: pt.node.isRequired,
  };

  render() {
    const {
      rootRest,
      triggerChildren,
      triggerClassName,
      triggerRest,
      contentClassName,
      contentRest,
      disabled,
      children,
    } = this.props;

    return (
      <Root {...rootRest}>
        <Trigger asChild disabled={disabled}>
          <button
            type="button"
            className={
              triggerClassName ? triggerClassName : 'dropdown-menu-trigger'
            }
            {...triggerRest}
          >
            {triggerChildren}
          </button>
        </Trigger>
        <Portal>
          <Content
            className={
              contentClassName ? contentClassName : 'dropdown-menu-content'
            }
            {...contentRest}
          >
            {children}
          </Content>
        </Portal>
      </Root>
    );
  }
}
